export default "__VITE_ASSET__Bo6ibb7N__"